import React from 'react';
import { createRoot } from 'react-dom/client';
import { WebsiteManager as Website } from './utils';
import Main from './pages/Main';
import './assets/site.scss';
// import './organisms/profileuser/ProfileUser.scss';

// function Main() {
//     return <p>{'Test'}</p>;
// }

/* Security */
Website.setSecureSalt('RnNaCoHe3VzcP3L5Q9');

function main () {
    const app = new Website('yarflam');
    app.entry(
        'init',
        () => {
            const target = document.querySelector('#root');
            if (target) createRoot(target).render(<Main />);
        },
        {
            once: true,
            autostart: true
        }
    );
}
main();